import { jsx as _jsx } from "react/jsx-runtime";
import { Dropdown } from '@catawiki/cata-style';
import { RFC4646_LOCALES_TO_LABELS, RFC4646Locale } from '@catawiki/locale';
import * as styles from './LocaleSelector.module.scss';
import { pushTrackingEvent } from '../../../../../shared/utils/eventTracking';
import { reloadPageWithHost } from '../../../../../shared/utils/reloadWithHost';
import { useLocale } from '../../../../../hooks/useLocale';
export const LocaleSelector = () => {
    const currentLocale = useLocale();
    const selectedLocale = currentLocale || undefined;
    const handleLocaleChange = (locale) => {
        const host = `${window.location.host}/${locale}`;
        pushTrackingEvent({
            event: 'ga-event',
            eventCategory: 'Localisation events',
            eventAction: 'Language switch - clicked',
            eventLabel: locale,
        });
        reloadPageWithHost(host, locale);
    };
    const handleLocaleSelectClick = () => {
        pushTrackingEvent({
            event: 'ga-event',
            eventCategory: 'Localisation events',
            eventAction: 'Language switch - opened',
            eventLabel: '',
        });
    };
    const localeLabels = Object.values(RFC4646Locale).map((locale) => ({
        value: locale,
        label: RFC4646_LOCALES_TO_LABELS[locale],
    }));
    return (_jsx("div", { className: styles.container, children: _jsx(Dropdown, { value: selectedLocale, items: localeLabels, onChange: handleLocaleChange, onClick: handleLocaleSelectClick }) }));
};
//# sourceMappingURL=LocaleSelector.js.map